import React from "react"
import PropTypes from "prop-types"
import FieldContainer from "../../../../components/layouts/containers/FieldContainer.container"
import InputTextForm from "../../../../components/molecules/InputTextForm.molecule"
import InputNumberForm from "../../../../components/molecules/InputNumberForm.molecule"
import UnifiedDatePickerForm from "../../../../components/molecules/UnifiedDatePickerForm.molecule"
import IconWithTooltip from "../../../../components/molecules/IconWithTooltip.molecule"
import Label from "../../../../components/atoms/Label.atom"
import { UNIFIEDDATE_VALUES } from "../../../../consts/CompoundRangeDatePicker"

const MilestoneSection = ({ formData, setFormData }) => {
  const updateMilestoneField = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      milestone: {
        ...prev.milestone,
        [field]: value,
      },
    }))
  }

  const getMinDateForMilestone = () => {
    if (!formData.endDate) return null
    return formData.endDate.plus({ days: 1 })
  }

  return (
    <>
      <FieldContainer md={12} className="mb-2">
        <h3 className="font-cairo text-xl font-semibold">
          Milestone del proyecto
        </h3>
      </FieldContainer>

      <FieldContainer md={6}>
        <div className="flex gap-1 align-items-center mb-2">
          <Label>Puntos totales hasta el milestone</Label>
          <IconWithTooltip
            iconClassName="pi pi-info-circle"
            tooltipValue="Total de puntos estimados para completar el milestone"
          />
        </div>
        <InputNumberForm
          value={formData.milestone?.totalPoints}
          onChange={(e) => updateMilestoneField("totalPoints", e.value)}
          placeholder="Ej: 614"
          className="w-full"
          min={0}
        />
      </FieldContainer>

      <FieldContainer md={6}>
        <InputTextForm
          label="Nombre del milestone"
          value={formData.milestone?.milestoneName || ""}
          onChange={(e) =>
            updateMilestoneField("milestoneName", e.target.value)
          }
        />
      </FieldContainer>

      <FieldContainer md={6}>
        <UnifiedDatePickerForm
          label="Próxima fecha importante"
          hasSingleWeek={false}
          hasSingleMonth={false}
          hasDayPeriod={false}
          hidePeriodSelector
          hideChevron
          dateRange={[
            formData.milestone?.nextImportantDate,
            formData.milestone?.nextImportantDate,
          ]}
          setDateRange={(e) => updateMilestoneField("nextImportantDate", e[0])}
          period={UNIFIEDDATE_VALUES.SINGLEDAY}
          format="dd/MM/yyyy"
          datePickerProps={{
            className: "w-full",
            minDate: getMinDateForMilestone(),
          }}
          disabled={!formData.endDate}
        />
      </FieldContainer>

      <FieldContainer md={6}>
        <InputTextForm
          label="Nombre de la fecha importante"
          value={formData.milestone?.nextImportantDateName || ""}
          onChange={(e) =>
            updateMilestoneField("nextImportantDateName", e.target.value)
          }
        />
      </FieldContainer>
    </>
  )
}

MilestoneSection.propTypes = {
  formData: PropTypes.object.isRequired,
  setFormData: PropTypes.func.isRequired,
}

export default MilestoneSection
